import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// material-ui
import { Button, DialogContent, Dialog, DialogActions, Typography, Box } from '@mui/material'

// third party
import { useSnackbar } from 'notistack'

// project import
import { useEventBusContext } from 'services/provider/EventBusProvider'
import { bannerSlideDelete } from 'models/banner'
import { EVENT_BANNER_SLIDE_DELETE_INIT, EVENT_BANNER_SLIDE_UPDATE_SUCCESS } from 'models/events/banner.event'

/*
 * Initiate banner slide delete dialog.
 */
export const BannerSlideDeleteDialog = () => {
    const eventbus = useEventBusContext()
    const [slidedelete, setSlideDelete] = useState(null)

    useEffect(() => {
        return eventbus.on(EVENT_BANNER_SLIDE_DELETE_INIT, (data) => setSlideDelete(data))
    }, [eventbus])

    return (
        <Dialog open={slidedelete != null} scroll={'body'} maxWidth="sm" fullWidth onClose={() => setSlideDelete(null)}>
            {slidedelete && <BannerSlideDelete
                slidedelete={slidedelete}
                onClose={() => setSlideDelete(null)}
                onSuccess={(data) => {
                    eventbus.fire(EVENT_BANNER_SLIDE_UPDATE_SUCCESS, data)
                    setSlideDelete(null)
                }}
            />}
        </Dialog>
    )
}

/**
 * Banner slide delete dialog.
 */
const BannerSlideDelete = ({ slidedelete, onClose, onSuccess }) => {
    const slide = slidedelete
    const { enqueueSnackbar } = useSnackbar()
    const [isDeleting, setIsDeleting] = useState(false)

    const onSubmit = async () => {
        setIsDeleting(true)
        await bannerSlideDelete(slide.id || slide)
            .then((res) => {
                onSuccess(res.data)
                enqueueSnackbar(res.message || 'Slide deleted successfully', { variant: 'success', autoHideDuration: 2000 })
            })
            .catch((res) => {
                enqueueSnackbar(res.message || 'Failed to delete slide', { variant: 'error', autoHideDuration: 2000 })
                setIsDeleting(false)
            })
    }

    return (
        <Box>
            <DialogContent dividers sx={{ px: 4, py: 4 }}>
                <Typography variant="h5" sx={{ pr: 2 }}>Are you sure you want to delete {slide?.title ? slide.title : 'this slide'}?</Typography>
            </DialogContent>
            <DialogActions sx={{ p: 1.5 }}>
                <Button onClick={onClose} type="button" variant="outlined" color="error">Cancel</Button>
                <Button type="submit" variant="contained" color="error" onClick={onSubmit} disabled={isDeleting}>
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Box>
    )
}

//BannerSlideDelete component prop type declaration
BannerSlideDelete.propTypes = {
    slidedelete: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default BannerSlideDelete